import React from "react";
import {
  Grid,
  Typography,
  Box,
  alpha,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import FacebookOutlined from "@mui/icons-material/FacebookOutlined";
import InstagramOutlined from "@mui/icons-material/Instagram";
import PublicOutlined from "@mui/icons-material/PublicOutlined";
import BusinessOutlined from "@mui/icons-material/BusinessOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FormField from "./FormField";
import { FileUpload } from "../../../components";

const CompleteSetupStep = ({
  formData,
  handleChange,
  logo,
  handleFileChange,
}) => {
  const theme = useTheme();

  return (
    <Grid container spacing={3}>
      <Grid item size={12}>
        <Accordion
          disableGutters
          sx={{
            borderRadius: "12px !important",
            border: "1px solid #D9E2EC",
            boxShadow: "none",
            "&:before": { display: "none" },
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: "#64748B" }} />}>
            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: 700,
                fontFamily: theme.typography.fontFamily,
                display: "flex",
                alignItems: "center",
                gap: 1,
                color: "#F9735B",
              }}
            >
              <PublicOutlined sx={{ color: "#F9735B" }} />
              Social Media Links (Optional)
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ pt: 0 }}>
            <Grid container spacing={3}>
              <FormField
                label="Facebook (Optional)"
                name="facebook"
                value={formData.facebook}
                onChange={handleChange("facebook")}
                placeholder="https://facebook.com/yourpage"
                icon={<FacebookOutlined sx={{ color: "#1877F2" }} />}
                gridSize={12}
              />

              <FormField
                label="Instagram (Optional)"
                name="instagram"
                value={formData.instagram}
                onChange={handleChange("instagram")}
                placeholder="https://instagram.com/yourhandle"
                icon={<InstagramOutlined sx={{ color: "#E4405F" }} />}
                gridSize={12}
              />
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>

      <Grid item size={12}>
        <Box
          sx={{
            p: 3,
            borderRadius: 2.5,
            border: `2px dashed ${alpha(theme.palette.primary.main, 0.3)}`,
            background: alpha("#F9735B", 0.05),
            transition: "all 0.3s ease",
            "&:hover": {
              borderColor: "#F9735B",
              background: alpha("#F9735B", 0.08),
            },
          }}
        >
          <Typography
            variant="subtitle2"
            gutterBottom
            sx={{
              fontWeight: 700,
              fontFamily: theme.typography.fontFamily,
                display: "flex",
                alignItems: "center",
                gap: 1,
                mb: 2,
                color: "#334155",
              }}
            >
              <BusinessOutlined sx={{ color: "#F9735B" }} />
              Upload Restaurant Logo
            </Typography>
          <FileUpload
            accept="image/*"
            multiple={false}
            onChange={handleFileChange}
          />
          {logo && (
            <Box
              sx={{
                mt: 2,
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                p: 2,
                borderRadius: 2,
                background: alpha(theme.palette.success.main, 0.1),
              }}
            >
              <CheckCircleOutlineIcon
                sx={{ color: theme.palette.success.main }}
              />
              <Typography
                variant="body2"
                sx={{
                  color: theme.palette.success.main,
                  fontWeight: 600,
                  fontFamily: theme.typography.fontFamily,
                }}
              >
                {logo.name}
              </Typography>
            </Box>
          )}
        </Box>
      </Grid>
    </Grid>
  );
};

export default CompleteSetupStep;

